export enum WeaponProficiencies {
    Unarmed = 'Unarmed Attacks',
    Simple = 'Simple Weapons',
    Martial = 'Martial Weapons',
    Advanced = 'Advanced Weapons',
}
